import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { NAV_OFFSET, useSmoothScroll } from "../context/SmoothScrollContext";

/**
 * Rola até a seção do hash (/#Sobre) — inclusive vindo de outra página —
 * e volta ao topo ao clicar em "Home" estando na própria Home.
 */
export const useHashScroll = () => {
  const location = useLocation();
  const { scrollTo } = useSmoothScroll();
  const firstRun = useRef(true);

  useEffect(() => {
    const isFirst = firstRun.current;
    firstRun.current = false;

    if (!location.hash) {
      if (!isFirst) scrollTo(0);
      return;
    }

    const id = decodeURIComponent(location.hash.slice(1));
    // Na primeira renderização espera o layout assentar.
    const timer = window.setTimeout(
      () => {
        const el = document.getElementById(id);
        if (el) scrollTo(el, { offset: NAV_OFFSET });
      },
      isFirst ? 150 : 0,
    );
    return () => window.clearTimeout(timer);
  }, [location.hash, location.key, scrollTo]);
};
